import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  requirements: {
    parents: [],
    sections: []
  },
  categories: [],
  isLoading: false
})

const getters = {
  requirements: (state) => state.requirements,
  categories: (state) => state.categories,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_REQUIREMENTS(state, payload) {
    state.requirements.parents = payload.parent
    state.requirements.sections = payload.sections
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchRequirements({ commit, dispatch }) {
    axiosWithToken
      .get(`${adminBaseUrl}/requirements/category`)
      .then((res) => {
        commit('SET_REQUIREMENTS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
  },
  fetchCategories({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_CATEGORIES', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createCategory({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/category`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/categories')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteCategory(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/category/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchCategory(_context, { id, vm }) {
    vm.ctLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/category/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.imageUrl = message.image
        vm.iconUrl = message.icon
        vm.imageEnUrl = message.image_en
        vm.imageRuUrl = message.image_ru
        vm.editForm.nameEn = message.name_en
        vm.editForm.nameRu = message.name_ru
        vm.editForm.parent_id = message.parent_id
        vm.editForm.section_id = message.section_id
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.ctLoading = false
      })
  },
  updateCategory(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.ctLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/category/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editCategoryModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.ctLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
